
export class Bookmarks {
    constructor(){
        this.Bookmarks = BOOKMARKS;
        this.length = this.Bookmarks.length;
    }

    get(i){
        return this.Bookmarks[i];
    }

    getZoom(i){
        return this.Bookmarks[i][3];
    }

    getLon(i) {
        return this.Bookmarks[i][1];
    }

    getLat(i) {
        return this.Bookmarks[i][2];
    }
}


let BOOKMARKS = [
    ["Deutsch-Ostafrika", 35.2589, -6.2043, 5],
    ["Deutsch-Neuguinea", 150.0487, 6.8808, 4],
    ["Deutsch-Südwestafrika", 16.9784, -23.0891, 5],
    ["Kamerun", 13.5379, 5.8262, 5],
    ["Kiautschou", 120.3932, 36.0761, 9],
    ["Samoa", 187.8960, -13.8115, 10],
    ["Togo", 0.3285, 8.0835, 6],
    ["Witu", 40.8111, -2.2223, 10]
    ]
    